import ConfigurationService from '../ConfigurationService'
import { CurrencyEnum, Config, CurrencyList } from './coins.types'
import * as coins from './coins.json'

export type BetLimitT = { [key in keyof CurrencyEnum]: { min: number; max: number } }

type ParserCoins = {
  all: CurrencyList
  external: CurrencyList
  bet_limit: BetLimitT
}

export const getParsedCoins = ({ currencies_list }: { currencies_list: CurrencyList }) => {
  return Object.entries(currencies_list)
    .sort((a, b) => (a[1].order || 999) - (b[1].order || 999))
    .reduce(
      (acc, [key, value]) => {
        if (currencies_list[key].active === true) {
          acc['all'][key] = currencies_list[key]
        }
        if (currencies_list[key].external === true) {
          acc['external'][key] = currencies_list[key]
        }
        acc['bet_limit'][key] = { min: 100, max: 10000000 }
        return acc
      },
      { all: {}, external: {}, bet_limit: {} } as ParserCoins
    )
}

export function findConfig(currency, unit): Config {
  const currencyConfig = coins[currency]
  if (!currencyConfig) {
    throw new Error(`Currency ${currency} not found`)
  }
  const unitConfig = currencyConfig.units[unit]
  if (!unitConfig) {
    throw new Error(`Currency unit ${currency} ${unit} not found`)
  }
  return Object.assign(unitConfig, { precision: currencyConfig.precision })
}

export const fromInteger = (amount: number | string, currency: string, unit?: string) => {
  const config = findConfig(currency, unit || currency)
  const intAmount = +amount
  if (intAmount % 1 !== 0) {
    throw new Error(`Expected integer amount, got ${amount}`)
  }
  return intAmount / Math.pow(10, config.precision - config.shift)
}

export function convertUnit(amount: number | string, currency: string, fromUnit: string, toUnit: string) {
  const fromConfig = findConfig(currency, fromUnit)
  const toConfig = findConfig(currency, toUnit)
  const roundPrecision = Math.pow(10, toConfig.precision - toConfig.shift)
  return Math.round(+amount * Math.pow(10, toConfig.shift - fromConfig.shift) * roundPrecision) / roundPrecision
}

export const getLogoForCoin = (currency: string) => {
  if (!currency) {
    return undefined
  }

  const coins = ConfigurationService.instance.getCurrencies()
  const coin = coins[currency.toUpperCase()]
  if (coin) {
    return `https://cdn.blackjack.fun/optimized/coins/${coin.code.toLocaleLowerCase()}.webp`
  }
  return 'https://cdn.blackjack.fun/optimized/coins/coin.webp'
}
